import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

export type EstadoTransportistaBody = {
  m_estado_id: string;
  m_rut_estado: string;
};

/** POST /api/transportista/estado/set */
@Injectable({ providedIn: 'root' })
export class TransportistaEstadoSetGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: EstadoTransportistaBody,
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/estado/set', body, options);
  }
}
